$('.location-list-container .store-image-wrapper .image-container-slider').each(function(index, slider) {
  var $slider = $(slider);
  var $progressBar = $slider.closest('.store-image-wrapper').find('.progress');
  var $progressBarLabel = $slider.closest('.store-image-wrapper').find('.slider__label');
  
  // Initialize slick for each slider
  $slider.slick({
    infinite: false,
    arrows: false,
    dots: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
  });

  // Function to update the progress bar
  function updateProgress(slick, currentSlide) {
    var calc = ((currentSlide + 1) / slick.slideCount) * 100;

    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc.toFixed(10));

    $progressBarLabel.text(calc.toFixed(4) + '% completed');
  }

  // On slider initialization, check the number of slides and set the initial progress bar value
  $slider.on('init', function(event, slick) {
    if (slick.slideCount === 1) {
      // Hide the progress bar if there's only one slide
      $progressBar.hide();
    } else {
      // Show the progress bar and update it if there are more than one slide
      $progressBar.show();
      updateProgress(slick, slick.currentSlide);
    }
  });

  // Update progress bar on slide change
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    if (slick.slideCount > 1) {
      updateProgress(slick, nextSlide);
    }
  });

  // Trigger the init event after setting up the slider
  $slider.slick('setPosition');

  // Manually trigger the init event
  $slider.trigger('init', [$slider.slick('getSlick')]);
});  

$('#cleaning-step').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: `<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  nextArrow: `<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
        arrows: false,
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: true,
      }
    }
  ]
}); 

if(window.innerWidth < 750) {  
  $('.shoe-cleaning-step .section-title').click(function(){
    if($(this).hasClass('active')){
       $(this).removeClass('active');
       $('.shoe-cleaning-step .content-and-slider-container').fadeOut(200);
    }else{
       $('#cleaning-step').slick('refresh');
      $(this).addClass('active');
      $(`[data-tab-content="${ $(this).attr('data-tab-title') }"]`).fadeIn(200); 
    }
  })
}



// login
$( document ).ready(function() {
 setTimeout(function () {
    $('.form-block .tabs li:first-child a').trigger('click');
  }, 200);

  $(".form-block .tabs li a" ).click(function(e) {
    e.preventDefault();
    $( '.form-block .tabs li a').removeClass('active');
    $( this ).addClass('active');
    var CurrentTab = $( this ).attr('tab-id');
    var selectTab = '[data-tab-id="'+ CurrentTab +'"]';

    $(".account-control .form-block .form-field-container .customer").hide();
    $(selectTab).fadeIn('fast');
     // $('.article-block .article').slick('refresh');
  });

// Slider in Login and Sign up Page
  $('.account-control .image-block .slider-images').slick({
    infinite: false,
    dots:true,
    slidesToShow: 1,
    slidesToScroll: 1
  });


  let currentPageUrl = window.location.pathname;
  // let splitedUrl = currentPageUrl.split('/');
  
  let sideBarUrl = document.querySelectorAll('.member-account-page .member-page-container .page-list-container ul li a')
  sideBarUrl.forEach((val) => {
    // console.log(typeof val.getAttribute('href'))
    if(val.getAttribute('href') != '' && val.getAttribute('href') != '#'){
      if(currentPageUrl == val.getAttribute('href')){
        val.classList.add('active');
      }
    }
  })
  
});

// login ends

$(document).ready(function(){
  
  function imageProductSlider(){
    $('.image-with-text-product-slider').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.1,
      slidesToScroll: 1,
      prevArrow: `<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
      nextArrow: `<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
    }); 
  }
  
  imageProductSlider();
  document.addEventListener("ajaxloader:render", imageProductSlider);
}); 

$(document).ready(function(){
  function initializeSlick() {
    $('.grid-image-slider').slick({
      speed: 300,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // prevArrow: `<button class="slide-arrow prev-arrow"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 22L3 12L13 2" stroke="#1F1F1F" stroke-width="3"/></svg></button>`,
      // nextArrow: `<button class="slide-arrow next-arrow"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 22L3 12L13 2" stroke="#1F1F1F" stroke-width="3"/></svg></button>`,
    });
  }

  document.addEventListener("filter:product:grid:updated", function () {
    setTimeout(() => {
      initializeSlick();
    }, 500);
  });

  document.addEventListener("recommend:product:grid:image:slider", function () {
    // setTimeout(() => {
      initializeSlick();
    // }, 500);
  });

  // document.dispatchEvent(new CustomEvent("recommend:product:grid:image:slider"));

  initializeSlick();                         
});